/** Sentinel value for "no paid promotion" in shared card selectors (not a `ToplistingVariant`). */
export const TOPLISTING_PROMOTION_NONE = 'NO_PROMOTION';

/** Regional Highlight is a slot-backed visibility product, not a ToplistingVariant. */
export const REGIONAL_HIGHLIGHT_PROMOTION_VALUE = 'REGIONAL_HIGHLIGHT';

/** Border / top-accent color for Premium promotion card (first in row). */
export const TOPLISTING_PROMOTION_CARD_ACCENT_PREMIUM = '#101968';

/** Border / top-accent for Top Listing card (default selection). */
export const TOPLISTING_PROMOTION_CARD_ACCENT_TOP = '#0E6969';

/** Border / top-accent for Lifetime Top Listing card. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_LIFETIME = '#8DA2B4';

/** Regional Highlight uses the neutral dove accent from the product design. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_REGIONAL_HIGHLIGHT = '#8DA2B4';

/** Top Listing Abo uses the same accent as daily Top. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_TOP_ABO = TOPLISTING_PROMOTION_CARD_ACCENT_TOP;

/** Selected-card background by column index (repeats for 4+ cards). */
export const TOPLISTING_PROMOTION_CARD_SELECTED_BACKGROUNDS = [
  '#f5f6ff',
  '#f2ffff',
  '#f5f6ff',
] as const;

/** One-time fee for rental listings (Flex Rent) in CHF */
export const FLEX_RENT_PRICE_CHF = 370;

/** One-time fee for sale listings (Flex Buy) in CHF */
export const FLEX_BUY_PRICE_CHF = 505;

/** Flex package pricing configuration */
export const FLEX_PACKAGE_PRICING = {
  RENT: FLEX_RENT_PRICE_CHF,
  BUY: FLEX_BUY_PRICE_CHF,
} as const;
